<template>
  <el-card
      id="leftBox"
      :title="title"
      style="margin-top: 10px !important; min-width: 358px !important"
  >
    <div class="tops">
      <div
          style="font-size: 20px;color:'#333333';font-weight: 700;display: flex;justify-content: space-between;align-content: center">
        <span>{{ title }}</span>
        <span>
          <span class="tips_info">{{ $t('common.urgent') }}</span>
          <span class="tips_info">{{ $t('common.normal') }}</span>
        </span>
      </div>
      <!--      <el-button-->
      <!--          @click="addFriend"-->
      <!--          slot="extra"-->
      <!--          v-if="extra === 'addfriend'"-->
      <!--          type="primary"-->
      <!--          link-->
      <!--      >{{ $t("common.more") }}-->
      <!--      </el-button>-->
      <el-button size="small" type="primary" @click="handleClickAdd">{{ $t('common.need.create') }}</el-button>
    </div>
    <div class="mainBox" slot="content">
      <ElCalendar ref="Calendar"></ElCalendar>
    </div>
  </el-card>
</template>

<script setup>
import {ref, defineProps, watch, computed, onMounted, nextTick, onUnmounted} from 'vue'
import {ElCard} from "element-plus";
import ElCalendar from "./index.vue"
import {useStore} from "vuex";

const {title} = defineProps({
  title: {
    type: String,
    default: ''
  }
})
const date = ref();
const value = ref(new Date())

const dayTime = computed(() => store.state.calendar.dateList)
const tag = computed(() => store.state.calendar.tag)
const mainKey = ref(1);
const store = useStore()


// watch(() => tag.value, () => {
//   // 对已有的数据进行去重处理 避免 紧急、普通 点 重复
//   mainKey.value++
// },)
const queryData = computed(() => store.state.calendar.queryData)

const Calendar = ref()
const handleClickAdd = () => {
  if (Calendar.value) {
    Calendar.value.handleAdd()
  }
}

let observer = null;
let observer2 = null;
let retryCount = 0;
const MAX_RETRY = 600;

const SELECTORS = {
  leftElement: '#teams_id',
  target: '.list_cal',
  leftBox: '#leftBox',
  cardBox: '.teamId_card_box_height'
};

const setListCalHeight = () => {
  const leftElement = document.querySelector(SELECTORS.leftElement);
  const target = document.querySelector(SELECTORS.target);
  const leftBox = document.querySelector(SELECTORS.leftBox);
  const cardBox = document.querySelector(SELECTORS.cardBox);

  // 如果任一元素不存在，延迟重试
  if (!leftElement || !target || !leftBox || !cardBox) {
    if (retryCount < MAX_RETRY) {
      retryCount++;
      setTimeout(setListCalHeight, 100);
    } else {
      console.warn('setListCalHeight: 元素未找到，停止尝试。');
    }
    return;
  }

  // 找到所有元素后重置重试计数
  retryCount = 0;

  const updateHeight = () => {
    const teamHeight = leftElement.getBoundingClientRect().height;
    const cardHeight = 700
    const finalHeight = teamHeight <= cardHeight ? cardHeight : teamHeight;

    console.log('更新高度:', teamHeight, cardHeight, finalHeight);

    // leftBox.style.height = `${finalHeight}px`;
    leftBox.style.maxHeight = `${finalHeight}px`;
  };

  // 初始化更新一次
  updateHeight();

  // 设置 observer 监听
  observer?.disconnect();
  observer2?.disconnect();

  observer = new MutationObserver(updateHeight);
  observer.observe(leftElement, {childList: true, subtree: true});

  observer2 = new MutationObserver(updateHeight);
  observer2.observe(cardBox, {childList: true, subtree: true});
};


onMounted(async () => {
  await nextTick();
  setListCalHeight();
  window.addEventListener('resize', setListCalHeight);
});

onUnmounted(() => {
  window.removeEventListener('resize', setListCalHeight);
  if (observer) observer.disconnect();
});


</script>

<style lang="less" scoped>
@import "./less/index";

#leftBox {
  box-sizing: border-box !important;
  transition: all 0s !important;
}
</style>
